import { AssetDTO } from "src/app/shared/models/models";



export class flatData {
  orgName: string = '';
  mainTitle: string = '';
  subTitle: string = '';
  logo: AssetDTO = new AssetDTO();
  mainImage: AssetDTO = new AssetDTO();
}
export class BrandContentModel {
  flatData: any = new flatData();
}
